module.exports = __webpack_public_path__ + "img/logo_landscape_color.014395f2.svg";